import { adapter, initialState, State } from './automation.state'
import * as R from 'ramda'
import { createReducer, on, Action } from '@ngrx/store'
import {
  LoadAutomations,
  LoadAutomationsComplete,
  PauseAutomationComplete,
  UnPauseAutomationComplete,
  ArchiveAutomationComplete,
  UnArchiveAutomationComplete,
  AddAutomationComplete,
  AddAutomationFailed,
  DeleteAutomationComplete,
  UpdateAutomationsComplete,
  AddAutomation,
  UpdateAutomations,
  UnArchiveAutomation,
  ArchiveAutomation,
  UnPauseAutomation,
  PauseAutomation,
  RecreateAutomation,
} from './automation.actions'
import { ActionFailed, ActionSkipped } from '@tokeet-frontend/tv3-platform'

export const reducer = createReducer(
  initialState,
  on(LoadAutomations, (state) => ({ ...state, isLoading: true })),
  on(LoadAutomationsComplete, (state, { automations }) =>
    adapter.setAll(automations, R.merge(state, { isLoaded: true, isLoading: false }))
  ),
  on(
    //
    PauseAutomationComplete,
    UnPauseAutomationComplete,
    ArchiveAutomationComplete,
    UnArchiveAutomationComplete,
    (state, { changes }) =>
      adapter.updateMany(changes, {
        ...state,
        isUpdating: false,
      })
  ),
  // One Save in the Autopilot Wizard queues one create per automation row, so the flag
  // has to follow the whole queue. Clearing it on the first completion re-enabled the
  // controls while later rows were still saving (TV4-6238).
  on(AddAutomation, (state) => ({
    ...state,
    pendingAdds: state.pendingAdds + 1,
    isAdding: true,
  })),
  on(RecreateAutomation, (state) => ({
    ...state,
    isAdding: true,
  })),
  on(AddAutomationComplete, (state, { automations }) => {
    const pendingAdds = Math.max(0, state.pendingAdds - 1)
    return adapter.addMany(automations, {
      ...state,
      pendingAdds,
      isAdding: pendingAdds > 0,
    })
  }),
  on(AddAutomationFailed, (state) => {
    const pendingAdds = Math.max(0, state.pendingAdds - 1)
    return {
      ...state,
      pendingAdds,
      isAdding: pendingAdds > 0,
    }
  }),
  on(UpdateAutomations, UnArchiveAutomation, ArchiveAutomation, UnPauseAutomation, PauseAutomation, (state) => ({
    ...state,
    isUpdating: true,
  })),
  on(UpdateAutomationsComplete, (state, { updates }) =>
    adapter.updateMany(updates, {
      ...state,
      isUpdating: false,
    })
  ),
  on(DeleteAutomationComplete, (state, { ids }) => adapter.removeMany(ids, state)),
  on(ActionFailed, (state) => ({
    ...state,
    isLoading: false,
    isAdding: state.pendingAdds > 0,
    isUpdating: false,
  })),
  on(ActionSkipped, (state) => ({
    ...state,
    isLoading: false,
    isAdding: state.pendingAdds > 0,
    isUpdating: false,
  }))
)

export function automationsReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
